import $ from '~/qwery';

export default class ErrorTip {
    constructor(input, msg) {
        if ($(input).data('error-tip'))
            return $(input).data('error-tip');
        $(input).data('error-tip', this);
        this.$input = $(input);

        const $inputWrapper = $(document.createElement('div'));
        $inputWrapper.addClass('error-tip-input-wrapper');
        if ($(input).css('display') == 'block')
            $inputWrapper.addClass('block');
        this.$input.replaceWith($inputWrapper)
        $inputWrapper.append(this.$input);

        const $wrapper = $(document.createElement('div'));
        $wrapper.addClass('error-tip-wrapper');
        $wrapper.html('<div class="b-error-tip"></div>');
        $inputWrapper.append($wrapper);
        this.$el = $('.b-error-tip', $wrapper);

        this.msg(msg);
    }

    show(show = true) {
        if (show)
            this.$el.css('top', - Math.round(this.$el[0].offsetHeight / 2) + 'px');
        this.$el[show ? 'addClass' : 'removeClass']('visible');
    }

    hide() {
        this.show(false);
    }

    msg(value) {
        if (arguments.length) {
            this._msg = value;
            this.$el.text(this._msg);
            if (this.$el[0].getBoundingClientRect()['right']
            > document.documentElement.clientWidth)
                this.$el.addClass('wrap');
        }
        return this._msg;
    }
}



// WEBPACK FOOTER //
// ./makosh/assets/components/error-tip.js